<!--
 * @Description: 产品类型销售额统计 - 柱状图（带俪丰/联农切换）
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
-->
<template>
  <div class="bar-chart">
    <div class="header">
      <div class="title">
        <img src="@/img/datav-tc/title_icon.png" alt="" />
        <span>产品类型销售额统计</span>
      </div>
      <div class="tab">
        <div :class="['tab-item', { active: type == 'lifeng' }]" @click="typeChange('lifeng')">
          俪丰
        </div>
        <div :class="['tab-item', { active: type == 'liannong' }]" @click="typeChange('liannong')">
          联农
        </div>
      </div>
    </div>
    <div id="SaleTypeBarChart" style="width:100%;height:calc(100% - 70px)"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getSaleTypeBar, getGroupStoreList } from '@/api/dashboard-tc'
let myChart

export default {
  data() {
    return {
      type: 'lifeng',
      data: {
        categories: [],
        values: [],
      },
      appidMap: {},
      timer: null,
    }
  },
  mounted() {
    myChart = echarts.init(document.getElementById('SaleTypeBarChart'))
    myChart.resize()
    window.addEventListener('resize', () => {
      myChart.resize()
    })
    this.initAppid()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    async initAppid() {
      try {
        const res = await getGroupStoreList()
        if (res.code === 0 && res.data) {
          res.data.forEach(item => {
            if (item.storeName.includes('俪丰')) {
              this.appidMap.lifeng = item.appid
            } else if (item.storeName.includes('联农')) {
              this.appidMap.liannong = item.appid
            }
          })
          this.fetchData()
          this.timer = setInterval(() => {
            this.fetchData()
          }, process.env.VUE_APP_LTIME_TC)
        }
      } catch (error) {
        console.error('获取集团列表失败:', error)
      }
    },
    async fetchData() {
      try {
        const appid = this.type === 'lifeng' ? this.appidMap.lifeng : this.appidMap.liannong
        if (!appid) {
          console.warn('appid未获取到')
          return
        }
        const res = await getSaleTypeBar(appid)
        if (res.code === 0) {
          this.data = {
            categories: res.data.categories,
            values: res.data.values,
          }
          this.initChart()
        }
      } catch (error) {
        console.error('获取销售额统计失败:', error)
      }
    },
    initChart() {
      if (!this.data || !this.data.categories || this.data.categories.length === 0) {
        return
      }

      // 霓虹色彩方案
      const neonColors = [
        { start: '#FF006E', end: '#8338EC' },
        { start: '#3A86FF', end: '#00F5FF' },
        { start: '#FFBE0B', end: '#FB5607' },
        { start: '#06FFA5', end: '#00C9A7' },
        { start: '#FF4081', end: '#F50057' },
        { start: '#00C0FE', end: '#126DFF' },
        { start: '#A855F7', end: '#6366F1' },
        { start: '#F59E0B', end: '#EF4444' },
      ]

      const formattedData = this.data.values.map((value, index) => {
        const colorSet = neonColors[index % neonColors.length]
        return {
          value,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: colorSet.start },
              { offset: 1, color: colorSet.end },
            ]),
            borderRadius: [6, 6, 0, 0],
            shadowBlur: 10,
            shadowColor: colorSet.start + '80',
          },
        }
      })

      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(5, 13, 76, 0.9)',
          borderColor: '#00c0fe',
          borderWidth: 1,
          textStyle: {
            fontSize: 14,
            color: '#fff',
          },
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: 'rgba(0, 192, 254, 0.1)',
            },
          },
          formatter: params => {
            const data = params[0]
            const colorSet = neonColors[data.dataIndex % neonColors.length]
            return `
              <div style="padding: 8px;">
                <div style="font-size: 14px; color: #899dbf; margin-bottom: 4px;">${data.name}</div>
                <div style="font-size: 16px; font-weight: bold; color: ${colorSet.start};">销售额: ${data.value}万元</div>
              </div>
            `
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '15%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: this.data.categories,
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 12,
            color: 'rgba(255, 255, 255, 0.7)',
            rotate: 25,
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
              type: 'dashed',
            },
          },
          axisLabel: {
            fontSize: 12,
            color: 'rgba(255, 255, 255, 0.7)',
          },
        },
        series: [
          {
            name: '销售额',
            type: 'bar',
            barWidth: '45%',
            data: formattedData,
            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowColor: 'rgba(0, 192, 254, 0.8)',
              },
            },
            label: {
              show: true,
              position: 'top',
              fontSize: 11,
              color: '#fff',
              formatter: params => {
                return `{value|${params.value}}`
              },
              rich: {
                value: {
                  fontSize: 11,
                  color: '#fff',
                  fontWeight: 'bold',
                  textShadowBlur: 5,
                  textShadowColor: 'rgba(0, 192, 254, 0.8)',
                },
              },
            },
            animationDuration: 1500,
            animationEasing: 'elasticOut',
          },
        ],
      }
      myChart.setOption(option)
    },
    typeChange(type) {
      this.type = type
      this.fetchData()
    },
  },
}
</script>

<style lang="scss" scoped>
.bar-chart {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 20px 25px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0px;

    .title {
      font-size: 24px;
      color: #ecf8ff;
      display: flex;
      align-items: center;

      img {
        margin-right: 3px;
      }
    }

    .tab {
      display: flex;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 20px;
      border: 1px solid rgba(0, 192, 254, 0.3);
      padding: 3px;
      margin-top: 10px;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        inset: -2px;
        background: linear-gradient(90deg, #00c0fe, #126dff, #00c0fe);
        border-radius: 22px;
        z-index: -1;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &:hover::before {
        opacity: 0.3;
      }

      .tab-item {
        width: 60px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.7);
        cursor: pointer;
        transition: all 0.3s ease;
        border-radius: 13px;
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(0, 192, 254, 0.2), rgba(18, 109, 255, 0.2));
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        &:hover {
          color: #66ffff;

          &::before {
            opacity: 1;
          }
        }

        &.active {
          background: linear-gradient(90deg, #00c0fe 0%, #126dff 100%);
          color: #fff;
          box-shadow: 0 0 15px rgba(0, 192, 254, 0.5), inset 0 0 10px rgba(255, 255, 255, 0.2);
          font-weight: 600;

          &::before {
            display: none;
          }
        }
      }
    }
  }
}
</style>
